import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface ComposerSectionAddButtonProps {
  onClick?: () => void;
}

/*
 * Style.
 */

const StyledButtonDiv = styled(ChromelessButton)`
  display: grid;
  grid-template-columns: 12px 4px auto;
  grid-template-areas: 'icon . label';
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade60};
  padding: 4px;
  border-radius: 4px;

  &:hover {
    color: ${(p) => p.theme.greys.shade80};
    background-color: ${(p) => p.theme.alphas.gray10};
  }
`;

const StyledLabelDiv = styled.div`
  grid-area: label;
  display: inline-block;
`;

const StyledIconDiv = styled.div`
  grid-area: icon;
  ${center()};
`;

/*
 * Component.
 */

export const ComposerSectionAddButton: FC<PropsWithChildren<ComposerSectionAddButtonProps>> = (props) => (
  <StyledButtonDiv onClick={props.onClick}>
    <StyledIconDiv>
      <Icon name="plusTiny" />
    </StyledIconDiv>
    <StyledLabelDiv>{props.children}</StyledLabelDiv>
  </StyledButtonDiv>
);
